<header class="header-page">
    <h1 class="header__page__content__title">
        Simulação de Empréstimo
    </h1>
</header>
<main class="main__content">
    <section class="main__content__iframe">
        <iframe *ngIf="!loading" id="iframe-emprestimo" [src]="trustedUrl"></iframe>
    </section>
</main>